/**
 * Device Mockup Generator (Phone/Laptop) — Tool Manifest
 */
import type { ToolManifest } from "../../../lib/tool";

export const manifest: ToolManifest = {
  id: "device-mockup-generator",
  name: "Device Mockup Generator (Phone/Laptop)",
  description: "Wrap screenshots in device mockups: iPhone, Android, MacBook, Surface, etc. Realistic shadows.",
  category: "image",
  keywords: ["device mockup", "phone mockup", "laptop mockup", "screenshot mockup"],
  icon: "Smartphone",
  requiresNetwork: false,
  seo: {
    title: "Device Mockup Generator (Phone/Laptop) — 100% Private, Offline | UnQTools",
    faq: [
      { q: "What does this tool do?", a: "Wrap screenshots in device mockups: iPhone, Android, MacBook, Surface, etc. Realistic shadows." },
      { q: "Is my data sent to a server?", a: "No. This tool runs 100% in your browser. Nothing is uploaded, tracked, or stored remotely." },
      { q: "What extra features does this tool have?", a: "Extras: (1) (1) iPhone 15 Pro mockup, (2) (2) Pixel 8 mockup, (3) (3) MacBook Pro mockup, (4) (4) iPad mockup, (5) (5) Surface mockup, (6) (6) Shadow effect, (7) (7) Background color, (8) (8) Perspective tilt, (9) (9) Download as PNG, (10) (10) Copy HTML+CSS, (11) (11) Bulk processing, (12) (12) PWA offline" },
      { q: "Does this work offline?", a: "Yes — install as a PWA and use it without network." },
    ],
  },
  status: "done",
};
